export default "__VITE_ASSET__QVGruuvz__"